import { getAreaId } from "./helpers";
import { ExportManager } from "./ExportManager";
export function getApi(dataStore, lastInRoute) {
    return {
        exec: dataStore.in.exec.bind(dataStore.in),
        on: dataStore.out.on.bind(dataStore.out),
        intercept: dataStore.in.intercept.bind(dataStore.in),
        getState: dataStore.getState.bind(dataStore),
        getReactiveState: dataStore.getReactive.bind(dataStore),
        setNext: ev => (lastInRoute = lastInRoute.setNext(ev)),
        getStores: () => ({ data: dataStore }),
        getCard: id => {
            const { cards } = dataStore.getState();
            return cards.find(card => card.id == id);
        },
        serialize: () => {
            const { cards, links, columns, rows } = dataStore.getState();
            return {
                cards,
                links,
                columns,
                rows,
            };
        },
        export: new ExportManager(dataStore),
        undo: dataStore.undo.bind(dataStore),
        redo: dataStore.redo.bind(dataStore),
        getAreaCards: (columnId, rowId) => {
            const { cardsMap } = dataStore.getState();
            const areaId = getAreaId(columnId, rowId);
            return cardsMap[areaId];
        },
    };
}
//# sourceMappingURL=api.js.map